import { Box } from "@chakra-ui/react";

export const LightSource = () => {
  const color1 = "rgb(250, 238, 122)";
  const color2 = "rgb(255, 237, 73)";
  const color3 = "rgba(253, 204, 57, 0.4)";
  const color4 = "rgba(253, 216, 53, 0)";
  return (
    <Box
      position="absolute"
      left={"50%"}
      top={"-50px"}
      w={"100px"}
      h="100px"
      opacity={0.7}
      borderRadius="50%"
      bg={`radial-gradient(circle,${color1},${color2} 10%,${color3} 40%,${color4} 70%)`}
    />
  );
};
